import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';


interface PersonalInformationProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    thread?: ThreadAction;
}
@inject('app', 'site')
@observer
class PersonalInformation extends BasePage<PersonalInformationProps> {
    componentDidMount() {
        const { site } = this.props;
        if (site) {
            site.setShowHeader(false);
        }
        super.componentDidMount();
    }

    componentWillUnmount() {
        const { site } = this.props;
        if (site) {
            site.setShowHeader(true);
        }
    }
    render() {
        const { app } = this.props;
        const platform = app?.platform || 'h5';
        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
           return (<div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                {platform === 'pc' ? (<PC></PC>) : (
                    <H5></H5>
                )}
            </div>)
        }
        
    }
}

export default withRouter(PersonalInformation);